import axios from 'axios'

export const state = {
  items: [],
  bookmark: '',
  groupPriceUpdates: [],
  foodDepartment: [],
}

export const getters = {
  getItems(state) {
    return state.items
  },
  getGroupPriceUpdates(state) {
    return state.groupPriceUpdates
  },
  getFoodDepartment(state) {
    return state.foodDepartment
  },
}

export const mutations = {
  SET_ITEMS(state, newValue) {
    state.items = newValue
  },
  SET_ITEM_BOOKMARK(state, newValue) {
    state.bookmark = newValue
  },
  SET_PRICE_UPDATES(state, newValue) {
    state.groupPriceUpdates = newValue
  },
  SET_FOODDEPARTMENT(state, newValue) {
    state.foodDepartment = newValue
  },
}

export const actions = {
  fetchItems({ commit, state }, { params }) {
    return axios
      .get(`/v1/items/`, {
        params: params,
      })
      .then(response => {
        const items = response.data.docs
        // commit('SET_ITEMS', items)
        commit('SET_ITEM_BOOKMARK', response.data.bookmark)
        if (items.length > 0) {
          console.log(items)
          return items
        } else {
          return 'No items'
        }
      })
      .catch(err => {
        throw err
      })
  },
  fetchItemsByGroup({ commit, state }, { params }) {
    return axios
      .get(`/v1/items/getByGroup/`, {
        params: params,
      })
      .then(response => {
        const items = response.data.docs
        // commit('SET_ITEMS', items)
        commit('SET_ITEM_BOOKMARK', response.data.bookmark)
        if (items.length > 0) {
          console.log(items)
          return items
        } else {
          return 'No items'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getModifierItems({ commit }, outletId) {
    return axios.get(`v1/items/${outletId}`).then(response => {
      return response
    })
  },
  getUpdateDocs({ commit }, outletId) {
    return axios.get(`v1/items/updateDocs/${outletId}`).then(response => {
      return response
    })
  },
  getPriceUpdates({ commit, state }, { params }) {
    return axios
      .get(`v1/items/getupdates/`, {
        params: params,
      })
      .then(response => {
        commit('SET_PRICE_UPDATES', response.data.docs)
        return response.data.docs
      })
  },
  getFoodDepartmentbyID({ commit }, outletId) {
    return axios.get(`v1/foodDepartment/${outletId}`).then(response => {
      return response.data.docs
    })
  },
  getCLCompanies({ commit }, groupId) {
    return axios.get(`v1/cityLedger/company/${groupId}`).then(response => {
      return response
    })
  },

  insertCategory({ commit, state }, { categoryObject }) {
    return axios
      .post(`v1/items/insertCategory`, categoryObject)
      .then(response => {
        return response.data
      })
  },

  insertModiferItem({ commit, state }, { itemObject }) {
    return axios
      .post(`v1/items/insertmodifierItem`, itemObject)
      .then(response => {
        return response.data
      })
  },

  UpdateModiferItem({ commit, state }, { itemObject }) {
    return axios
      .put(`v1/items/updatemodifierItem`, itemObject)
      .then(response => {
        return response.data
      })
  },

  UpdateItemUpdate({ commit, state }, { itemObject }) {
    return axios.put(`v1/items/updateItemUpdate`, itemObject).then(response => {
      return response.data
    })
  },

  updateItem({ commit, state }, { itemObject }) {
    return axios.put(`v1/items/`, itemObject).then(response => {
      debugger
      return response.data
    })
  },

  insertModiferItemtoItemDoc({ commit, state }, { itemObject }) {
    return axios
      .post(`v1/items/insertmodifierItemtoItemDoc`, itemObject)
      .then(response => {
        return response.data
      })
  },

  updateModiferItem({ commit, state }, { itemObject }) {
    return axios
      .put(`v1/items/insertmodifierItemUpdate`, itemObject)
      .then(response => {
        return response.data
      })
  },

  insertItem({ commit, state }, { itemObject }) {
    return axios.post(`v1/items/`, itemObject).then(response => {
      return response.data
    })
  },

  deleteModiferItem(
    { commit, state },
    { documentId: modiferId, rev: modiferRev }
  ) {
    return axios
      .delete(`/v1/items/${modiferId}/${modiferRev}`)
      .then(response => {
        return response.data
      })
  },

  bulkPriceUpdateItems({ commit, state }, { payload }) {
    return axios.post(`/v1/items/bulkUpdate`, { payload }).then(response => {
      return response.data
    })
  },
}
